// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"476":"57bab4ca","536":"321070b1"}[chunkId] + ".css";
};